module.exports = __webpack_public_path__ + "img/ott_5.0a85602f.png";